<template>
  <section class="rev-ras-featured-post-carrousel-module-component">
    <div class="rr-container">
      <button
        type="button"
        class="back-button"
        aria-label="Go back to the previous page"
        @click="goBack">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          aria-hidden="true">
          <g clip-path="url(#article-back-arrow-clip)">
            <path
              d="M10 0.843751L10 1.28125L6.35514 4.9375C4.29907 7 3.52025 7.4375 3.30218 7.6875C3.14642 7.84375 3.14642 7.9375 3.17757 8.0625C3.20872 8.1875 3.33333 8.25 3.52025 8.25C3.89408 8.25 5.01558 8.0625 7.6324 8.0625L19.6885 8.0625L20 8.375L20 9.65625L19.6885 9.96875L7.60125 9.96875C4.98443 9.96875 3.86293 9.78125 3.4891 9.78125C3.30218 9.78125 3.17757 9.84375 3.14642 9.96875C3.11527 10.0938 3.11527 10.1875 3.27103 10.3438C3.4891 10.5625 4.26791 11.0313 6.32399 13.0938L9.96885 16.75L9.96885 17.1875L9.12773 18.0312L8.69159 18.0312L8.14125e-07 9.3125L7.64949e-07 8.75L8.69159 9.88613e-07L9.12773 9.50484e-07L9.96885 0.843751L10 0.843751Z"
              fill="#1E6B5C" />
          </g>
          <defs>
            <clipPath id="article-back-arrow-clip">
              <rect
                width="18"
                height="20"
                fill="white"
                transform="translate(20) rotate(90)" />
            </clipPath>
          </defs>
        </svg>
        <span>Back</span>
      </button>
      <div class="title-container">
        <h2
          v-if="data.section_title"
          v-html="data.section_title"></h2>
      </div>
    </div>
    <div class="rr-container carousel">
      <div class="carousel-container">
        <Splide
          ref="splideRef"
          :options="trackOptions"
          :has-track="false"
          aria-label="Posts"
          @splide:mounted="(splide) => (currentIndex = splide.index)"
          @splide:moved="(_, newIndex) => (currentIndex = newIndex)">
          <div
            v-show="displayedArticles.length > 1"
            class="splide__arrows">
            <button
              class="splide__arrow splide__arrow--prev rotate-180"
              type="button"
              :disabled="isFirstSlide"
              @click="splideRef?.go('<')">
              <div class="navigation-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none">
                  <path
                    d="M24.9023 12L12.9023 24L11.2256 22.3232L20.3633 13.1855L-1.15272e-06 13.1855L-9.45344e-07 10.8135L20.3623 10.8135L11.2256 1.67676L12.9023 1.12796e-06L24.9023 12Z"
                    fill="#00206A" />
                </svg>
              </div>
            </button>
            <button
              class="splide__arrow splide__arrow--next"
              type="button"
              :disabled="isLastSlide"
              @click="splideRef?.go('>')">
              <div class="navigation-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none">
                  <path
                    d="M24.9023 12L12.9023 24L11.2256 22.3232L20.3633 13.1855L-1.15272e-06 13.1855L-9.45344e-07 10.8135L20.3623 10.8135L11.2256 1.67676L12.9023 1.12796e-06L24.9023 12Z"
                    fill="#00206A" />
                </svg>
              </div>
            </button>
          </div>
          <SplideTrack>
            <SplideSlide
              v-for="(carousel, idx) of displayedArticles"
              :key="`carousel-item-${idx}`">
              <div
                class="carousel-card"
                :href="carousel?.permalink || '#'"
                :alt="carousel?.post_title"
                :target="carousel?.permalink ? '_self' : '_blank'">
                <div class="card-image">
                  <img
                    :src="carousel?.acf?.carrousel_image.url"
                    class="card-image-tag" />
                </div>
                <div class="card-text">
                  <div class="title-info">
                    <p
                      v-if="articleCategoryName(carousel)"
                      class="article-category"
                      v-html="articleCategoryName(carousel)"></p>

                    <div
                      v-if="articleCategoryName(carousel)"
                      class="divider-container">
                      <BicolorLine
                        :bigger="false"
                        left="humble"
                        right="progressive" />
                    </div>

                    <p
                      v-if="carousel?.post_title"
                      class="article-name"
                      v-html="carousel?.post_title"></p>
                  </div>

                  <div class="title-info">
                    <div class="author-container">
                      <p
                        v-if="carousel?.acf?.author"
                        class="author">
                        By: {{ carousel?.acf?.author }}
                      </p>
                      <p
                        v-if="carousel?.acf?.published_date"
                        class="date">
                        {{ formatPublishedDate(carousel?.acf?.published_date) }}
                      </p>
                    </div>

                    <div
                      class="description"
                      v-html="carousel?.acf?.description"></div>
                    <a
                      :href="carousel?.permalink || '#'"
                      class="carousel-link"
                      >Read More</a
                    >
                  </div>
                </div>
              </div>
            </SplideSlide>
          </SplideTrack>
        </Splide>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "RevRASFeaturedPostCarrouselComponent",
  "CLASSNAME": "rev-ras-featured-post-carrousel-module-component",
  "URL": "http://vuevitewp.local/test"
 }
#ENDMETA */

/*
 * Insert your logic here
 */
import BicolorLine from '@/components/utility/BicolorLine.vue'
import { useStore } from '@/stores/main'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css/core'
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
const props = defineProps(['data'])

const router = useRouter()
const store = useStore()
const newestArticles = ref([])
const splideRef = ref(null)
const currentIndex = ref(0)
let newestArticlesRequestId = 0

const goBack = () => {
  router.back()
}

const pullNewestArticles = computed(() =>
  [true, 1, '1'].includes(props.data?.pull_newest_posts)
)

const maximumNumberOfPosts = computed(() => {
  const maximum = Number.parseInt(props.data?.maximum_number_of_posts, 10)

  return Number.isFinite(maximum) ? maximum : 0
})

const normalizeArticle = (article) => ({
  ...article,
  post_title: article?.post_title || article?.title?.rendered || '',
  permalink: article?.permalink || article?.link || '',
})

const selectedArticles = computed(() =>
  Array.isArray(props.data?.articles)
    ? props.data.articles.map(normalizeArticle)
    : []
)

const displayedArticles = computed(() =>
  pullNewestArticles.value ? newestArticles.value : selectedArticles.value
)

const isFirstSlide = computed(() => currentIndex.value === 0)

const isLastSlide = computed(
  () => currentIndex.value >= displayedArticles.value.length - 1
)

const loadNewestArticles = async () => {
  const activeRequest = ++newestArticlesRequestId

  if (!pullNewestArticles.value) {
    newestArticles.value = []
    return
  }

  try {
    const maximum = maximumNumberOfPosts.value
    const perPage = maximum > 0 ? Math.min(maximum, 100) : 100
    const articles = []
    let page = 1
    let totalPages = 1

    do {
      const request = {
        type: 'articles',
        params: {
          per_page: perPage,
          page,
          orderby: 'date',
          order: 'desc',
        },
        showLoading: false,
      }

      await store.getItems(request)

      if (activeRequest !== newestArticlesRequestId) return

      articles.push(...store.requestedItems(request).map(normalizeArticle))

      const storedRequest = store.request(request)
      totalPages = Number.parseInt(storedRequest?.totalPages, 10) || 1
      page += 1
    } while (page <= totalPages && (maximum <= 0 || articles.length < maximum))

    if (activeRequest !== newestArticlesRequestId) return

    newestArticles.value = maximum > 0 ? articles.slice(0, maximum) : articles
  } catch (error) {
    if (activeRequest !== newestArticlesRequestId) return

    newestArticles.value = []
    console.error('Unable to load the newest articles.', error)
  }
}

watch([pullNewestArticles, maximumNumberOfPosts], loadNewestArticles, {
  immediate: true,
})

const articleCategoryName = (article) => {
  const category = article?.acf?.article_categories?.[0]

  if (category && typeof category === 'object') {
    return category.name || ''
  }

  return typeof category === 'string' && !/^\d+$/.test(category) ? category : ''
}

const formatPublishedDate = (rawDate) => {
  if (!rawDate) return ''

  const normalizedDate = String(rawDate).trim()

  if (!normalizedDate) return ''

  // Support ACF date formats like "YYYYMMDD" in addition to ISO-like values.
  const isoLikeDate = /^\d{8}$/.test(normalizedDate)
    ? `${normalizedDate.slice(0, 4)}-${normalizedDate.slice(
        4,
        6
      )}-${normalizedDate.slice(6, 8)}`
    : normalizedDate

  const parsedDate = new Date(isoLikeDate)

  if (Number.isNaN(parsedDate.getTime())) return normalizedDate

  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(parsedDate)
}

const trackOptions = {
  rewind: false,
  perPage: 1,
  perMove: 1,
  focus: 0,
  trimSpace: true,
  speed: 500,
  interval: 5000,
  pagination: true,
  arrows: false,
  padding: { right: '0' },
  type: 'slide',
  autoplay: false,
}
</script>

<style lang="scss" scoped>
.rev-ras-featured-post-carrousel-module-component {
  @apply bg-white pt-10 pb-[90px] lg:pb-0 lg:pt-2;

  .rr-container {
    @apply lg:pr-0;
  }

  .back-button {
    @apply mb-4 inline-flex cursor-pointer items-center gap-3 border-0 bg-transparent p-0;
    @apply lg:mb-12;

    span {
      @apply text-[13px] leading-[1.2] text-balanced underline;
    }
  }

  .title-container {
    @apply flex flex-col gap-7 lg:gap-10;

    h2 {
      @apply header-2 text-balanced;
    }
  }

  .cards-container {
    @apply pt-8 pb-[50px] flex flex-col gap-6 lg:flex-row lg:gap-14;
  }

  .carousel-card {
    @apply relative max-w-[500px] flex bg-functional overflow-hidden rounded-[27px] flex-col gap-6 w-full items-center;
    @apply lg:flex-row;

    .full-button {
      @apply absolute top-0 left-0 w-full h-full z-[100] cursor-pointer;
    }

    &:before {
      @apply pointer-events-none absolute top-0 left-0 w-full h-full z-2 opacity-0 bg-balanced transition-opacity duration-300 ease-out;
      content: '';
    }

    .card-image {
      @apply relative w-full h-[203px] object-cover object-center rounded-[27px] overflow-hidden;
      @apply lg:h-full lg:w-[500px] xl:w-[617px];

      img {
        @apply w-full h-full object-cover lg:absolute lg:top-0 lg:left-0;
      }
    }

    .card-text {
      @apply px-8 pb-4 flex flex-col lg:flex-1 lg:h-auto lg:justify-between lg:px-10 lg:gap-5 lg:py-6;

      .title-info {
        @apply mt-0;

        .description {
          :deep(*) {
            @apply text-[16px] text-humble leading-[1.2] mb-5 lg:text-[18px];
          }
        }

        .article-name {
          @apply text-[22px] leading-[26px] font-FKDisplayALT normal-case text-humble mb-9;
          @apply lg:text-[26px] lg:leading-[40px];
        }

        .article-category {
          @apply text-[18px] text-humble mb-3;
        }

        .divider-container {
          @apply mt-4 mb-5;
        }

        .author-container {
          @apply flex flex-col gap-1 mb-5;

          .author {
            @apply text-[14px] font-medium leading-none text-humble;
          }

          .date {
            @apply text-[14px] font-medium text-humble leading-none;
          }
        }

        .carousel-link {
          @apply mt-11 mr-0 ml-auto w-fit text-humble transition-colors bg-progressive rounded-[29px] px-6 py-[4px] text-[14px] flex items-center;

          &:hover {
            @apply bg-humble text-progressive;
          }
        }
      }
    }
  }

  .carousel-container {
    @apply relative flex w-full h-full pt-9 lg:pb-[100px];
    @apply lg:pt-10;

    .carousel-card {
      @apply w-full max-w-none pointer-events-none;

      &:before {
        @apply opacity-40;
      }
    }

    .navigation-icon {
      @apply w-10 h-10 rounded-full bg-progressive flex items-center justify-center;

      svg {
        @apply w-5 h-5;

        path {
          @apply fill-humble;
        }
      }
    }

    .splide {
      @apply w-full;
      position: initial;

      .splide__track {
        @apply z-1;
        .splide__list {
          @apply gap-14;
          background: red;

          .splide__slide {
            @apply flex min-w-0;

            .carousel-card {
              @apply flex-1 lg:min-h-[500px];
            }
          }
        }
      }
      .splide__arrows {
        @apply flex justify-center items-center absolute bottom-[-55px] gap-[42px] right-0 left-0 w-full z-2;
        @apply lg:bottom-[40px] lg:right-[47px] lg:justify-end lg:left-auto lg:w-auto;

        .splide__arrow {
          @apply transition-opacity duration-300 ease-out;

          &[disabled] {
            @apply pointer-events-none cursor-default opacity-40;
          }
        }
      }
      .splide__pagination {
        @apply flex justify-center items-center z-2 gap-x-6 mt-12;
        .splide__pagination__page {
          @apply w-3 h-3 rounded-full bg-gray-500 cursor-pointer opacity-40;
          &.is-active {
            @apply opacity-100;
          }
        }
      }

      .splide__slide.is-active {
        .carousel-card {
          @apply pointer-events-auto;

          .card-image {
            p {
              @apply opacity-50;
            }
          }

          &:before {
            @apply opacity-0;
          }
        }
      }
    }
  }

  .button-container {
    @apply lg:pr-20;
  }
}
</style>
